// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9f7bd254","453":"a9ecfbe2"}[chunkId] + ".chunk.js";
};